/**
 * section-sw-trust.js — trust-bar testimonial marquee (H-C lane).
 *
 * Registered through the SWAnimations gate (assets/animations.js) per its
 * contract: reduced motion never creates the tween (the base CSS layout is a
 * static wrapped grid, satisfying c6 M-06 without any JS), the
 * IntersectionObserver defers setup, and the returned cleanup undoes the DOM
 * duplication + kills the tween/trigger on shopify:section:unload.
 *
 * h3 §6 mechanics: duplicated track, xPercent -50 seamless loop, drift
 * paused while off-screen and on hover, explicit pause control with
 * aria-pressed (c6 M-03/M-04/M-05). Speed ~50px/s (subtle intensity: 30).
 */
(function () {
  'use strict';

  if (!window.SWAnimations || window.__swTrustMarqueeRegistered) return;
  window.__swTrustMarqueeRegistered = true;

  window.SWAnimations.register('trust-bar', '[data-sw-trust-marquee]', function (el, gsap) {
    if (!window.ScrollTrigger) return;
    var track = el.querySelector('[data-sw-marquee-track]');
    if (!track) return;

    var originals = Array.prototype.slice.call(track.children);
    if (originals.length < 4) return; // too few cards to loop — stay a static grid

    /* Duplicate once for the seamless -50% loop; clones are decorative. */
    originals.forEach(function (card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      track.appendChild(clone);
    });

    el.classList.add('sw-trust--marquee-active');

    var speed = el.getAttribute('data-sw-intensity') === 'subtle' ? 30 : 50; // px/s, h3 §6 ambient band
    var distance = track.scrollWidth / 2;
    var duration = Math.max(20, distance / speed);
    var tween = gsap.to(track, { xPercent: -50, duration: duration, ease: 'none', repeat: -1 });
    var userPaused = false;

    var trigger = window.ScrollTrigger.create({
      trigger: el,
      start: 'top bottom',
      end: 'bottom top',
      onEnter: function () {
        if (!userPaused) tween.play();
      },
      onLeave: function () {
        tween.pause();
      },
      onEnterBack: function () {
        if (!userPaused) tween.play();
      },
      onLeaveBack: function () {
        tween.pause();
      }
    });

    var onEnterHover = function () {
      tween.pause();
    };
    var onLeaveHover = function () {
      if (!userPaused) tween.play();
    };
    el.addEventListener('mouseenter', onEnterHover);
    el.addEventListener('mouseleave', onLeaveHover);

    var pauseBtn = el.querySelector('[data-sw-marquee-pause]');
    var onPauseClick = function () {
      userPaused = !userPaused;
      pauseBtn.setAttribute('aria-pressed', String(userPaused));
      if (userPaused) {
        tween.pause();
      } else {
        tween.play();
      }
    };
    if (pauseBtn) pauseBtn.addEventListener('click', onPauseClick);

    return function () {
      tween.kill();
      trigger.kill();
      el.removeEventListener('mouseenter', onEnterHover);
      el.removeEventListener('mouseleave', onLeaveHover);
      if (pauseBtn) pauseBtn.removeEventListener('click', onPauseClick);
      while (track.children.length > originals.length) {
        track.removeChild(track.lastElementChild);
      }
      gsap.set(track, { clearProps: 'transform' });
      el.classList.remove('sw-trust--marquee-active');
    };
  });
})();
